export default "__VITE_ASSET__Blv$FxW$__"